import useFetchObjects from "../../api/useFetchObjects";

/**
 * Custom hook for fetching magazine list with filtering and pagination
 * @param {Object} filters - Filter parameters
 * @param {string} filters.frequency - Magazine frequency filter (e.g., 'WEEKLY', 'MONTHLY')
 * @param {string} filters.category - Magazine category filter
 * @param {string} filters.search - Search query
 * @param {string} sort - Sorting parameter
 * @param {number} page - Current page number
 * @returns {Object} Query result containing magazine data and loading state
 */
const useMagazineList = (filters, sort, page, page_size) => {
  const queryParams = new URLSearchParams();

  // Add filters
  if (filters.frequency) queryParams.append("frequency", filters.frequency);
  if (filters.category) queryParams.append("category", filters.category);
  if (filters.search) queryParams.append("search", filters.search);

  // Add sorting
  if (sort) queryParams.append("ordering", sort);

  // Add pagination
  queryParams.append("page", page);
  queryParams.append("page_size", page_size || "12"); // Showing fewer items per page for magazines

  return useFetchObjects(
    ["magazines", filters, sort, page, page_size],
    `magazines/?${queryParams.toString()}`,
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    },
  );
};

export default useMagazineList;
